import { render, staticRenderFns } from "./set07.vue?vue&type=template&id=8a421456&scoped=true&"
import script from "./set07.vue?vue&type=script&lang=js&"
export * from "./set07.vue?vue&type=script&lang=js&"
import style0 from "./set07.vue?vue&type=style&index=0&id=8a421456&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a421456",
  null
  
)

export default component.exports